import { Button, Flex, Heading, Text } from '@optiaxiom/react';
import { IconArrowLeft } from '@optimizely/axiom-icons';

type PageHeaderProps = {
  title: string;
  goBackText?: string;
  onClickGoBack?: () => void;
  headingText?: string | React.ReactNode;
  addOnsRight?: React.ReactNode;
  isEmbedded?: boolean;
};

export function PageHeader({
  title,
  headingText,
  goBackText,
  onClickGoBack,
  addOnsRight,
  isEmbedded,
}: PageHeaderProps) {
  return (
    <Flex gap="8" flexDirection="column" w={isEmbedded ? 'full' : '2/3'}>
      {goBackText && (
        <Button
          appearance="subtle"
          icon={<IconArrowLeft size="12" />}
          onClick={onClickGoBack}
          w="fit"
        >
          {goBackText}
        </Button>
      )}
      <Flex flexDirection="row" justifyContent="space-between" alignItems="center">
        <Flex flexDirection="column" gap="8">
          <Heading level="3" color="fg.default">
            {title}
          </Heading>
          {headingText && (
            <Text fontSize="md" color="fg.secondary">
              {headingText}
            </Text>
          )}
        </Flex>
        {addOnsRight && addOnsRight}
      </Flex>
    </Flex>
  );
}
